export enum VrsConferenceCallDetailsStatus {
  PARTICIPANT_DISCONNECTED = 'PARTICIPANT_DISCONNECTED',
  PARTICIPANT_CONNECTED = 'PARTICIPANT_CONNECTED',
  PARTICIPANT_CONNECTING = 'PARTICIPANT_CONNECTING',
  PARTICIPANT_RECONNECT = 'PARTICIPANT_RECONNECT',
  CHANGE_PARTICIPANT_NUMBER = 'CHANGE_PARTICIPANT_NUMBER',
  NEW_CALL = 'NEW_CALL',
}
